import React from "react"

import { Box, Flex, FlexProps, Text } from "@chakra-ui/react"
import { graphql, useStaticQuery } from "gatsby"
import { useCart } from "@app/hooks/useCart"
import Icon from "@app/components/Icon"

export type Props = {
  isCartPage?: boolean
} & FlexProps

export const CartError: React.FC<Props> = ({ ...rest }) => {
  const { unavailableItems } = useCart()
  const { cart } = useStaticQuery<GatsbyTypes.StaticCartErrorQuery>(graphql`
    query StaticCartError {
      cart: sanityPageCart {
        additionalUnavailableMessage
      }
    }
  `)

  const style = {
    borderRadius: "8px",
    py: 2,
    px: 5,
  }

  if (!unavailableItems.length) return null

  return (
    <Flex {...style} bg="preset.redAccent" gap={2} alignItems="start" {...rest}>
      <Box minWidth={5}>
        <Icon name="info" color="preset.red" width={5} fill="transparent" />
      </Box>
      <Text color="preset.red" size="sm">
        {cart?.additionalUnavailableMessage}
      </Text>
    </Flex>
  )
}
